import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BondTypes, Building, Company } from 'toolbandi-ui-lib';
import { ListItem, ListService, SharedDataService, CrudService, MessageService, Search } from 'elbuild-ui-lib-core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-building-edit',
	templateUrl: './building-edit.component.html',
	styleUrls: ['./building-edit.component.scss']
})
export class BuildingEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	building: Building;
	tab: string;
	editable: string;

	buildingtypes: ListItem[] = [];

	@Input()
	companyid: number;

	search: {
		company: Search
	};
	selected: {
		company: Company
	};

	title: string;
	bondtypes = [...Object.keys(BondTypes)].map(v => BondTypes[v]);


	constructor(
		private listService: ListService,
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private buildingService: CrudService<Building>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private companyService: CrudService<Company>,
		private activeModal: NgbActiveModal
	) {
		this.search = {
			company: new Search('company')
		};

		this.selected = {
			company: undefined
		};

		this.listService.getListItemsBySlug('building.type').subscribe(data => this.buildingtypes = data);
	}
	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.building = new Building();
				this.title = 'building-create';
				if (this.companyid) {
					this.building.companyid = this.companyid;
					this.findCompany(this.building.companyid);
				}

				this.loading = false;
			}
		});
	}

	load(id: number): void {
		this.loading = true;
		this.buildingService.getEntity(Building, 'building', id).subscribe(building => {
			this.building = building;
			this.title = 'building-edit';
			this.loading = false;
			this.initItem();
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.building'));
			this.building = undefined;
			this.loading = false;
		});

	}

	findCompany(cid: number): void {
		if (cid) {
			this.companyService.getEntity(Company, 'company', cid).subscribe((c: Company) => {
				this.selected.company = c;
			});
		}
	}

	initItem(): void {
		this.findCompany(this.building.companyid);
	}

	setSelectedFields(): void {
		this.building.companyid = this.selected.company.id;
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	submit(): void {
		this.setSelectedFields();
		if (!this.building.id) {
			this.buildingService.createEntity(Building, 'building', this.building).subscribe(response => {
				this.building = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.building-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.building);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.buildingService.saveEntity(Building, 'building', this.building).subscribe(response => {
				this.building = response;
				this.initItem();
				this.messageService.sendSuccess(
					this.translateService.instant('labels.building-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.building);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

}
